import React, { useContext, useEffect, useMemo, useState } from "react"
import api from "../apiConfig";
import { AuthContext } from "../../context/Auth.context";
import PaymentModal from "./PaymentModal";

const PathtoMvpComponent = ({ promptDataId }) => {

    const [technologyStack, setTechnologyStack] = useState('');
    const [developmentTimeline, setDevelopmentTimeline] = useState('');
    const [userOnboarding, setUserOnboarding] = useState('');
    const [marketValidation, setMarketValidation] = useState('');
    const [postLaunchEvaluation, setPostLaunchEvaluation] = useState('');
    const { state } = useContext(AuthContext);

    const fullReportInfo = async () => {
        if (promptDataId) {
            try {
                const token = JSON.parse(localStorage.getItem("token"))
                if (token) {
                    const response = await api.post("/buzz-startup-ai/get-buzzstartups-full-report", { token, promptDataId })
                    if (response.data.success) {
                        const technologyStackData = response?.data?.getFullReport?.pathToMVPTechnologyStack;
                        const developmentTimelineData = response?.data?.getFullReport?.pathToMVPDevelopmentTimeline;
                        const userOnboardingData = response?.data?.getFullReport?.pathToMVPUserOnboarding;
                        const marketValidationData = response?.data?.getFullReport?.pathToMVPMarketValidation;
                        const postLaunchEvaluationData = response?.data?.getFullReport?.pathToMVPPostLaunchEvaluation;
                        setTechnologyStack(technologyStackData);
                        setDevelopmentTimeline(developmentTimelineData);
                        setUserOnboarding(userOnboardingData);
                        setMarketValidation(marketValidationData);
                        setPostLaunchEvaluation(postLaunchEvaluationData);
                        return;
                    }
                }
            }
            catch (err) {
                console.log(err);
            }
        }
        else {
            console.log("Please provide prompt first");
        }
    }

    useEffect(() => {
        fullReportInfo();
    }, [])

    const formatContent = useMemo(() => {
        return (text) => {
            if (!text) return '';
            text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
            text = text.replace(/\*(.*?)\*/g, '<em>$1</em>');
            text = text.replace(/`(.*?)`/g, '<code>$1</code>');
            text = text.replace(/\b(https?:\/\/\S+)\b/g, '<a href="$1">$1</a>');
            text = text.replace(/(?:\r\n|\r|\n)/g, '<br>');
            text = text.replace(/(\d+\.\s[a-zA-Z]+:)/g, '<strong>$1</strong>');
            text = text.replace(/(\d+\.\s.*?:)/g, '<strong>$1</strong>');
            text = text.replace(/# (.*)/g, '<h1 style="font-size: 1.2em;">$1</h1>');
            return text;
        };
    }, []);


    return (
        <div>
            {state?.user?.paymentStatus ? (<div>
                <h2 className="text-center">Path to MVP</h2>
                <h5 className="mb-1 mt-3"><strong> Technology Stack</strong></h5>
                <div className="reportFontSize mb-4" dangerouslySetInnerHTML={{ __html: formatContent(technologyStack) }} />
                <h5 className="mb-0 mt-3"><strong> Development Timeline</strong></h5>
                <div className="reportFontSize mb-2" dangerouslySetInnerHTML={{ __html: formatContent(developmentTimeline) }} />
                <h5 className="mb-1 mt-3"><strong>User Onboarding</strong></h5>
                <div className="reportFontSize mb-2" dangerouslySetInnerHTML={{ __html: formatContent(userOnboarding) }} />
                <h5 className="mb-1 mt-3"><strong>Market Validation</strong></h5>
                <div className="reportFontSize mb-2" dangerouslySetInnerHTML={{ __html: formatContent(marketValidation) }} />
                <h5 className="mb-1 mt-3"><strong>Post-Launch Evaluation</strong></h5>
                <div className="reportFontSize mb-2" dangerouslySetInnerHTML={{ __html: formatContent(postLaunchEvaluation) }} />
            </div>) :
                (
                    <div>
                        <PaymentModal />
                    </div>
                )}
        </div>
    )
}

export default PathtoMvpComponent